var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 88,
    viewBox: "0 0 121 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5127 3.74316C21.2816 13.9099 22.8958 23.9709 23.0761 34.1873C23.2217 42.4399 23.0759 50.7155 22.9337 58.9667C22.7796 67.9019 22.7913 76.8353 22.7913 85.7715",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.2754H119.631",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9053 6.30617C31.9053 8.98735 33.3781 10.0088 35.9561 10.0088C37.541 10.0088 38.3707 10.2411 38.8834 8.60056C39.0793 7.97354 39.1301 7.09328 39.01 6.43276C38.613 4.24948 32.7597 2.15032 32.7597 4.88207",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6721 4.88212C60.7191 6.7612 61.8198 6.856 63.5045 6.57522C64.4181 6.42295 64.2291 3.76765 64.0267 3.1099C63.5937 1.70279 62.4966 2.03391 61.226 2.03391C59.7687 2.03391 59.248 2.3755 59.248 3.74283",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0154 5.73688C85.4431 5.73688 85.5999 4.76776 86.3065 2.60386C86.9995 1.91085 87.8029 1.97494 88.8699 2.03422C89.6906 2.07981 89.4671 3.50407 89.4395 4.02796C89.3895 4.97923 88.8789 5.73688 88.0154 5.73688Z",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.0851C32.1027 34.2905 32.8737 36.3835 33.2766 36.3298C34.2335 36.2022 35.1304 34.6143 35.7553 33.9894C37.843 31.9017 38.7083 28.9098 41 27",
    stroke: "#FB7C51",
    strokeWidth: 1.66807,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61 32.4043C63.8541 33.3557 66.0792 35.6742 69.0003 36.4045",
    stroke: "#FB7C51",
    strokeWidth: 1.74228,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6003 31C64.8669 33.1459 62.6337 35.8055 60 38.0003",
    stroke: "#FB7C51",
    strokeWidth: 1.74228,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35.0851C91.1027 35.2905 91.8737 37.3835 92.2766 37.3298C93.2335 37.2022 94.1304 35.6143 94.7553 34.9894C96.843 32.9017 97.7083 29.9098 100 28",
    stroke: "#FB7C51",
    strokeWidth: 1.66807,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3359 57.5898H39.8806",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 77.5117H41.0202",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58.0851C59.1027 58.2905 59.8737 60.3835 60.2766 60.3298C61.2335 60.2022 62.1304 58.6143 62.7553 57.9894C64.843 55.9017 65.7083 52.9098 68 51",
    stroke: "#FB7C51",
    strokeWidth: 1.66807,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60 78H66.8357",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57.4521H96.9845",
    stroke: "#FB7C51",
    strokeWidth: 2.56188,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78H97.975",
    stroke: "#FB7C51",
    strokeWidth: 2.48108,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.e793edff617579b6e875f1caf36a9ebb.svg";
export { ForwardRef as ReactComponent };